angular.module 'zc.projects'

.controller 'IncentiveEditCtrl', ($scope, $state, $translate, $filter, Page, Incentive, Devise, currentProject, discountTypes, incentive, currencies, environment) ->
  Page.setBodyClass ''
  $translate('projectsIncentives.edit.insentibu_henshuu').then((translation) ->
    Page.setTitle(translation)
  )

  $scope.incentive = incentive
  $scope.currentProject = currentProject
  $scope.discountTypes = discountTypes
  $scope.Devise = Devise

  $scope.start_at_obj = $filter('dateToDateObj')($scope.incentive.start_at)
  $scope.end_at_obj = $filter('dateToDateObj')($scope.incentive.end_at)

  $scope.currency = currencies[$scope.currentProject.currency]
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize
  $scope.priceInputs =
    discount_price: if $scope.incentive.discount_price then $scope.incentive.discount_price * $scope.currencyStep else 0
    minimum_price: if $scope.incentive.minimum_price then $scope.incentive.minimum_price * $scope.currencyStep else null
  $scope.environment = environment

  $scope.giftUrlParameter = $translate.instant('projectsIncentives.edit.giftUrlParameter', { parameter: 'zc_gift={{gift_parameter}}' });

  setPristine = ->
    $scope.incentiveEditForm.$setPristine()
    $scope.goToList()

  $scope.goToList = ->
    $state.go 'admin.projects.incentives',
      projectId: currentProject.id

  $scope.save = ->
    $scope.incentive.start_at = $filter('dateObjToDate')($scope.start_at_obj, $scope.currentProject.region)
    $scope.incentive.end_at = $filter('dateObjToDate')($scope.end_at_obj, $scope.currentProject.region)
    if $scope.incentive.id
      Incentive.update
        projectId: $scope.currentProject.id
        id: $scope.incentive.id
      ,
        incentive: $scope.incentive
      .then setPristine
    else
      Incentive.create
        projectId: $scope.currentProject.id
      ,
        incentive: $scope.incentive
      .then setPristine

  $scope.updatePriceByApplyingCurrency = (attribute) ->
    $scope.incentive[attribute] = $scope.priceInputs[attribute] / $scope.currencyStep

  $scope.$watchGroup ['incentive.discount_type', 'incentive.is_novelty', 'incentive.is_free_shipping'], ([discount_type, is_novelty, is_free_shipping]) ->
    return unless $scope.incentiveEditForm.discount_type
    valid = (discount_type isnt 'none') or !!is_novelty or !!is_free_shipping
    $scope.incentiveEditForm.discount_type.$setValidity('should_be_set_if_is_novelty_and_is_free_shipping_are_not_set', valid);



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/edit.controller.coffee